import L from 'leaflet';
import Vue from 'vue'

const state = {
  multiScreen: {
    open: false,
  },
  currentBaseMapIndex: 0, //当前激活地图集合图层索引
  baseMapLayersGroup: [], //底图图层集合数据
  specialLayers: [], //专题图层数据
  legendShow: true,
  mapMode: '2d', //地图模式 2d/3d/23d三种模式,
  isShowAllScreen: false, //是否全屏
  isShowLegend: false, //是否显示图例
  isShowMenu: true, //是否显示左侧菜单
  geojsonDataFlag: false, //底部查询详情列表是否显示
  isShowUploadBtn: false,
  currentActiveLayerIndex: null, //当前默认激活layerId vuex不适合存放复杂对象
  showBufferFlag: false,  //是否显示缓冲区分析
  showCoordsFlag:false, //是否显示坐标转换面板
  showListPop:false,
  anaRestData:{}, //分析服务地址
  targetCroods:'',   //目标坐标系
  acitveDis:APPCONFIG.InitDis, //初始化时的行政区划
  districtLayer:null, //行政区划图层
  showSpatialFlag: false, //空间叠加分析组件默认不显示
  spatialLayerGeoJSON:[], // 空间分析的空间对象GeoJSON
  currentMapState: null, //当前地图CRS,
  isShowSpaceTime: false,
  showRightButtonControl: true,
  skin: 'black',
  cityMapNumber: null,
  selectLayer:{
    layerType:null,
    id:null,
    dataSetType:null
  },//地图编辑选中图层的id和themesetting的layerType
  mapTablistMode:"spatial", //展示的内容面板类型  spatial为空间查询结果/statics为统计查询结果/query为单纯属性查询结果
  lastMapPosition: {
    mapMode: '2d',
    center: null,
    zoom: 0
  }, //用以保存在地图切换时地图的上一个最终位置
}

const getters = {

}

const mutations = {
  clearAll(state,type) {
    if(type == "start" || type == "all"){
      for(var i=window.startMarkerLayer.length-1; i >= 0; i--){
        var startLayerItem = window.startMarkerLayer[i];
        startLayerItem.remove();
      }
    }
    if(type == "end" || type == "all") {
      for(var i=window.endMarkerLayer.length-1; i >= 0; i--){
        var endLayerItem = window.endMarkerLayer[i];
        endLayerItem.remove();
      }
    }
    if(type == "mid" || type == "all") {
      for(var i=window.midMarkerLayer.length-1; i >= 0; i--){
        var midLayerItem = window.midMarkerLayer[i];
        midLayerItem.remove();
      }
    }
    if(type == "highlighte" || type == "all") {
      for(var i=window.highlighteLayer.length-1; i >= 0; i--) {
        var highlighteItem = window.highlighteLayer[i];
        highlighteItem.remove();
      }
    }else {
      for(var i=window.lineLayer.length-1; i >= 0; i--) {
        var lineItem = window.lineLayer[i];
        lineItem.remove();
      }
      for(var i=window.iconLayer.length-1; i >= 0; i--) {
        var iconItem = window.iconLayer[i];
        iconItem.remove();
      }
    }
    if(type == "all") {
      for(var i=window.lineLayer.length-1; i >= 0; i--) {
        var lineItem = window.lineLayer[i];
        lineItem.remove();
      }
      for(var i=window.iconLayer.length-1; i >= 0; i--) {
        var iconItem = window.iconLayer[i];
        iconItem.remove();
      }
    }
  },
  changeCityMapNumber(state,cityName) {
    state.cityMapNumber = cityName
  },
  changeDistrict(state,district){
    state.acitveDis = district
  },
  addDistrictLayer(state,layer){
    state.districtLayer = layer;
  },
  removeDistrictLayer(state){
    state.districtLayer = null;
  },
  changeAnaRestData(state,layer){
    state.anaRestData = layer;
  },
  removeRestData(state){
    state.anaRestData = {};
  },
  changListShow(state,flag){
    state.showListPop = flag;
  },
  changeCurrentActiveLayer(state, index) {
    state.currentActiveLayerIndex = index;
  },
  changeUploadBtn(state, flag) {
    if (flag && state.showBufferFlag) {
      state.showBufferFlag = false;
    }
    state.isShowUploadBtn = flag;
  },
  changeGeoJsonDataFlag(state, flag) {
    state.geojsonDataFlag = flag;
  },
  changeShowMenu(state, isShowMenu) {
    state.isShowMenu = isShowMenu
  },
  showHideLegend(state, isShowLegend) {
    state.isShowLegend = isShowLegend;
  },
  changeMapMode(state, mapMode) {
    state.mapMode = mapMode;
  },
  changeMapMultiScreen(state, multiScreen) {
    state.multiScreen = multiScreen;
  },
  changeShowAllScreen(state, isShowAllScreen) {
    state.isShowAllScreen = isShowAllScreen;
  },
  addBaseMapLayersGroup(state, baseMapLayersGroup) {
    state.baseMapLayersGroup = baseMapLayersGroup;
  },
  addLegend(state, {
    layer,
    legend
  }) {
    for (let i = 0; i < state.specialLayers.length; i++) {
      if (state.specialLayers[i].resID === layer.resID) {
        state.specialLayers[i].legend = legend;
        break;
      }
    }
  },
  addLayer(state, layer) {
    let flag = state.specialLayers.filter((item)=>{
      return item.resID === layer.resID;
    })
    if(flag.length === 0){
      layer.zIndex = state.specialLayers.length == 0 ? 10 : (state.specialLayers.length+1) * 10; //默认设置zIndex 方便后续调整图层顺序
      state.specialLayers.push(layer);
    }else{
      flag[0] = layer;
    }
  },
  removeAllSLayer(state) {
    state.specialLayers = []
  },
  removeLayer(state, layer) {
    for (let i = 0; i < state.specialLayers.length; i++) {
      if (state.specialLayers[i].resID == layer.resID) {
        state.specialLayers.splice(i, 1);
        break;
      }
    }
  },
  showHideLayer(state, {
    layer,
    flag
  }) {
    for (let i = 0; i < state.specialLayers.length; i++) {
      if (state.specialLayers[i].resID == layer.resID) {
        state.specialLayers[i].visible = flag;
        break;
      }
    }

  },
  changeSpecialLayer(state, specialLayers) {
    state.specialLayers = specialLayers
  },
  addUserMarkers(state,marker){
    for(var i=0;i<state.specialLayers.length;i++){
      if(state.specialLayers[i].id == marker.layerid){
        state.specialLayers[i].datas.push(marker);
        break;
      }
    };
  },
  updateUserMarkers(state,marker){
    for(var i=0;i<state.specialLayers.length;i++){
      if(state.specialLayers[i].id == marker.layerid){
        let markers=state.specialLayers[i].datas;
        let len = markers.length;
        for(var j=0; j<len; j++){
          if(markers[j].pkid == marker.pkid){
            markers.splice(j,1);
            markers.splice(j,0,marker);
          }
        }
      }
    };
  },
  delUserMarkers(state,marker){
    for(var i=0;i<state.specialLayers.length;i++){
      if(state.specialLayers[i].id == marker.layerid){
        let markers=state.specialLayers[i].datas;
        let len = markers.length;
        for(var j=0; j<len; j++){
          if(markers[j] == marker){
            markers.splice(j,1);
            break;
          }
        }
      }
    };
  },
  changeLayerOpacity(state, {
    layer,
    opacity
  }) {
    for (var i = 0; i < state.specialLayers.length; i++) {
      if (state.specialLayers[i].resID == layer.resID) {
        state.specialLayers[i].opacity = opacity
      }
    }
  },
  changeCurrentBaseMapIndex(state, index) {
    state.currentBaseMapIndex = index;
    var templayer = state.baseMapLayersGroup[0];
    Vue.set(state.baseMapLayersGroup, 0, state.baseMapLayersGroup[index]);
    Vue.set(state.baseMapLayersGroup, index, templayer);

  },
  changeMapboxglLayer(state, specialLayer){
    for (var i = 0; i < state.specialLayers.length; i++) {
      if (state.specialLayers[i].themeField == "value") {
        state.specialLayers[i].options = specialLayer.options
        state.specialLayers[i].geojson = specialLayer.geojson
      }
    }
  },
  changeLayerZIndex(state, {
    downLayer,
    upLayer
  }) {
    for (let i = 0; i < state.specialLayers.length; i++) {
      if (state.specialLayers[i].resID == downLayer.resID) {
        //let tempZIndex = downLayer.zIndex;
        var templayer = state.specialLayers[i];
        for (let j = 0; j < state.specialLayers.length; j++) {
          if (state.specialLayers[j].resID == upLayer.resID) {
            /*state.specialLayers[i].zIndex = upLayer.zIndex;
            state.specialLayers[j].zIndex = tempZIndex;*/
            Vue.set(state.specialLayers, i, state.specialLayers[j]);
            Vue.set(state.specialLayers, j, templayer);
            break;
          }
        }
      }
    }
  },
  changeBufferState(state, bufferState) {
    if (bufferState && state.isShowUploadBtn) {
      state.isShowUploadBtn = false;
    }
    state.showBufferFlag = bufferState;
  },
  changeCoordsState(state, coordsState) {
    if (coordsState && state.showCoordsFlag) {
      state.showCoordsFlag = false;
    }
    state.showCoordsFlag = coordsState;
  },
  changeTargetCroods(state, targetCroods) {
    state.targetCroods = targetCroods;
  },
  changeSpatialState(state, spatialState) {
    state.showSpatialFlag = spatialState;
  },
  addSpatialLayerGeoJSON(state, data) {
    state.spatialLayerGeoJSON[data.index]= data.data
  },
  clearAllSpatialLayerGeoJSON(state) {
    state.spatialLayerGeoJSON = [];
  },
  storeCurrentMapState(state, crs) {
    state.currentMapState = crs;
  },
  changeSpaceTimeVisible(state, flag) {
    state.isShowSpaceTime = flag;
  },
  toggleRightButtonControlVisible(state, flag) {
    state.showRightButtonControl = flag;
  },
  //地图定制专用
  changeSelectLayer(state,obj){
    state.selectLayer = obj;
  },
  clearSelectLayer(state){
    state.selectLayer.layerType = null;
    state.selectLayer.id = null;
    state.selectLayer.dataSetType = null
  },
  changeSpecilayerAttr(state,obj){
    let newlayer = state.specialLayers.find((layer) => layer.id == obj.id);
    for(let key in obj){
      if(key!='id'){
        Vue.set(newlayer,key,obj[key]);
      }
    };
  },
  removeLegend(state,id){
    let layer = state.specialLayers.find((item)=>item.id==id);
    if(layer){
      layer.legend = [];
    }

  },
  changeTableType(state, flag){
    state.mapTablistMode = flag;
  },
  storeLastMapPosition(state, position) {
    state.lastMapPosition = position;
  },
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/map.js